import React from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'pt-BR', label: 'PT' },
  { code: 'en-US', label: 'EN' },
];

export function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language;

  return (
    <div
      role="group"
      aria-label={t('language.selectLabel')}
      className={`flex items-center gap-1 rounded-full border border-white/15 bg-gray-900/80 p-1 shadow-lg shadow-black/25 backdrop-blur-md ${className}`}
    >
      {languages.map(({ code, label }) => {
        const active = current === code;
        return (
          <button
            key={code}
            type="button"
            aria-pressed={active}
            onClick={() => i18n.changeLanguage(code)}
            className={`min-h-[32px] rounded-full px-3 text-xs font-semibold uppercase tracking-wide transition ${
              active ? 'bg-white text-gray-900' : 'text-white/70 hover:text-white'
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default LanguageSwitcher;
